import { useDispatch, useSelector } from 'react-redux';
import { useMixpanel } from 'react-mixpanel-browser';

import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { AnalyticsFilter } from '../Analytics/AnalyticsFilter';
import { AnalyticsDateFilter } from '../Analytics/AnalyticsDateFilter';
import { FilterSeparator } from '../../filters/FilterSeparator';
import { ReportsManagerIcon } from '../../icons/analytics';
import { REPORTS_MANAGER_SET_FILTER } from '../../../store/reducers/reportsManager';
import { REPORTS_MANAGER_TYPES_DISPLAY_NAME, ReportsManagerStatuses } from '../../tables/reports-manager/consts';

import styles from '../Reports/ReportsPage.module.scss';

export function ReportsManagerFilters() {
  const dispatch = useDispatch();
  let { type: selectedTypes, status: selectedStatuses } = useSelector((state) => state.reportsManager.filters);
  const { name: supplierName } = useSelector((state) => state.role.supplier);
  const mixpanel = useMixpanel();
  const reportBi = (meta) => {
    reportBusinessActionToMixpanel(mixpanel, 'reports-manager-filter', meta);
  };

  if (selectedTypes.length === 0) {
    selectedTypes = Object.keys(REPORTS_MANAGER_TYPES_DISPLAY_NAME);
  }

  if (selectedStatuses.length === 0) {
    selectedStatuses = Object.keys(ReportsManagerStatuses);
  }

  const typeOptions = Object.entries(REPORTS_MANAGER_TYPES_DISPLAY_NAME).map(([value, label]) => ({
    value: value.toString(),
    label,
  }));

  const statusOptions = Object.entries(ReportsManagerStatuses).map(([value, data]) => ({
    value: value.toString(),
    label: data.label,
  }));

  return (
    <div className={styles.filters}>
      <AnalyticsDateFilter
        keyPrefix="reportsManager"
        onChange={(startDate, endDate) => {
          dispatch({
            type: REPORTS_MANAGER_SET_FILTER,
            payload: { dates: { start: new Date(startDate), end: new Date(endDate) } },
          });
          reportBi({ supplierName, filterType: 'date', startDate, endDate });
        }}
      />

      <FilterSeparator />

      <AnalyticsFilter
        title="Report Type"
        icon={<ReportsManagerIcon />}
        options={typeOptions}
        selected={selectedTypes}
        onChange={(value) => {
          dispatch({
            type: REPORTS_MANAGER_SET_FILTER,
            payload: { type: value },
          });
          reportBi({ supplierName, filterType: 'type', types: selectedTypes });
        }}
        withSearch
      />

      <AnalyticsFilter
        title="Status"
        icon={<ReportsManagerIcon />}
        options={statusOptions}
        selected={selectedStatuses}
        onChange={(value) => {
          dispatch({
            type: REPORTS_MANAGER_SET_FILTER,
            payload: { status: value },
          });
          reportBi({ supplierName, filterType: 'status', types: selectedStatuses });
        }}
        withSearch
      />
    </div>
  );
}
